
import React, { useMemo } from 'react';
import { components } from 'react-select';
import cx from 'classnames';
import Dropdown from '../../Dropdown';
import TagListItem from '../../TagListItem';


import dropdownStyleOverrides from '../styles/tagsSelectorDropdownStyles';
import '../styles/__tags-selector.scss';

function buildTagOptions(tagsListItems) {
  const [
  platformTags,
  workspaceTags,
  userTags] =
  [
  'PLATFORM',
  'WORKSPACE',
  'USER'].
  map((type) =>
  tagsListItems.filter(
    ({ tag: { tagType } }) => tagType === type
  )
  );

  return [
  ...platformTags,
  ...(workspaceTags.length ? [{
    label: 'Workspace',
    options: workspaceTags
  }] : []),
  ...(userTags.length ? [{
    label: 'Private',
    options: userTags
  }] : [])];

}
























export default function TagsSelector({
  tagsList: tagsListProp = [],
  selectedTags: selectedTagsProp = [],
  onChange,
  isClearable = false,
  className,
  ...props
}) {
  const onSelectionChange = (newSelection) => {
    const tagsSelection = newSelection.map(({ tag }) => tag);
    onChange(tagsSelection);
  };

  const {
    selectedOptions,
    tagOptions
  } = useMemo(() => {
    const tagsListItems = tagsListProp.map((tag) => ({
      value: tag.tagId,
      label: tag.label,
      tag
    }));

    return {
      selectedOptions: selectedTagsProp.reduce(
        (acc, { tagId }) => [
        ...acc,
        tagsListItems.find(({ value }) => value === tagId)],

        []
      ),
      tagOptions: buildTagOptions(tagsListItems)
    };
  },
  [tagsListProp, selectedTagsProp]);

  return (
    <Dropdown
      className={cx('tags-selector', className || '')}
      type="BUTTON"
      closeMenuOnSelect={false}
      placeholder="Search tags"
      defaultValue={selectedOptions}
      isMulti
      isSearchable
      isClearable={isClearable}
      onChange={onSelectionChange}
      options={tagOptions}
      selectStyles={dropdownStyleOverrides}
      components={{
        Option: ({ data: { tag }, data, ...optionProps }) =>
        <components.Option {...optionProps} data={data}>
            <TagListItem tag={tag} className="tags-selector__listItem" />
          </components.Option>

      }}
      {...props} />);


}